import * as React from 'react';
import { SyntheticEvent } from 'react';
import { WatchlistItem } from 'watchlist';

export type OnItemRemove = (item: WatchlistItem, event: SyntheticEvent) => void;

interface WatchlistItemProps {
    item: WatchlistItem
    onClickRemove: OnItemRemove
}

export class WatchlistItemView extends React.PureComponent<WatchlistItemProps, {}> {
    constructor(props: WatchlistItemProps, context: any) {
        super(props, context);
        this.handleClick = this.handleClick.bind(this);
    }

    public render() {
        const item = this.props.item;
        // eslint-disable-next-line react/jsx-no-target-blank
        const link = <a href={item.uri} title={item.name} target='_blank'>
            <span className="pl-wl-list-item-name">{item.name}</span>
            <i className="fas fa-external-link-square"/>
        </a>;

        return <tr className="pf-wl-list-item">
            <td className="pf-wl-list-item-name">
                {link}
            </td>
            <td className="pf-wl-list-item-manage">
                <button className="pf-wl-remove" onClick={this.handleClick}><i className="far fa-trash-alt"/></button>
            </td>
        </tr>;
    }

    private handleClick(event: SyntheticEvent) {
        const props = this.props;
        props.onClickRemove(props.item, event);
    }
}
